import React from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import DashboardWireframe from './components/dashboard/DashboardWireframe';
import NarrativeSection from './components/dashboard/NarrativeSection';
import { ApolloClient, InMemoryCache } from "@apollo/client";
import { ApolloProvider } from "@apollo/client/react";
import './App.css';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route
          path="/"
          element={<HomePage />}
        />
        <Route
          path="/dashboard"
          element={<DashboardWireframe />}
        />
      </Routes>
    </div>
  );
}

function HomePage() {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate('/dashboard');
  };

  return <NarrativeSection onGetStarted={handleGetStarted} />;
}

export default App;
